import { ReferrerActionTypes } from './referrer.types';

const getExtoleJwt = () => ({ type: ReferrerActionTypes.REQUEST_EXTOLE_JWT });
const getExtoleJwtSuccess = payload => ({ type: ReferrerActionTypes.GET_EXTOLE_JWT_SUCCESS, payload });
const getExtoleJwtFailure = () => ({ type: ReferrerActionTypes.GET_EXTOLE_JWT_FAILURE });
const setExtoleJwtLoading = loading => ({ type: ReferrerActionTypes.SET_EXTOLE_JWT_LOADING, payload: { loading } });

const actions = {
  referrer: {
    extoleJwt: {
      get: getExtoleJwt,
      success: getExtoleJwtSuccess,
      failure: getExtoleJwtFailure,
      setLoading: setExtoleJwtLoading,
    },
  },
};

export default actions;
